import { POLICIES } from "../lib/data";
import { Anchor } from "lucide-react";

export default function Policy() {
  return (
    <div data-testid="policy-page" className="bg-sand">
      <section className="pt-28 pb-12 max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="overline mb-5">Charter Policy</div>
        <h1 className="font-serif-display font-light text-5xl md:text-6xl lg:text-7xl text-navy leading-[1.02] max-w-4xl">
          The honest fine print.
        </h1>
        <p className="mt-6 text-[color:var(--am-muted)] max-w-2xl leading-relaxed">
          We keep our terms short, plain, and fair. If anything below raises a
          question, just ring us — we'd rather talk it through.
        </p>
      </section>

      <section className="max-w-[900px] mx-auto px-6 lg:px-12 pb-24">
        <div className="divide-y divide-[color:var(--am-line)]">
          {POLICIES.map((p, i) => (
            <div key={i} className="py-10 grid md:grid-cols-12 gap-6" data-testid={`policy-${i}`}>
              <div className="md:col-span-4 flex items-start gap-3">
                <Anchor size={18} strokeWidth={1.4} className="text-navy mt-1" />
                <h2 className="font-serif-display text-2xl text-navy leading-tight">{p.title}</h2>
              </div>
              <p className="md:col-span-8 text-[color:var(--am-muted)] leading-relaxed">{p.body}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
